import React, { useState } from 'react';
import { Draggable } from 'components/drag-and-drop';
import { Brikk } from 'components/Brikk';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { BrikkModal } from 'components/modals/BrikkModal';
import { useGetAccessRules } from '../../../../services/2n/access-rules';
import { AccessManagement2NPreview, AccessManagement2NModal } from './components';

export const AccessManagement2N = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isLoading } = useGetAccessRules();

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={isLoading}
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon="2N"
            heading="twoNAccessManagement"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content center>
            <AccessManagement2NPreview />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={() => setIsModalOpen(true)}
              brikkNameIntl="twoNAccessManagement"
           //   disabled
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>
      <BrikkModal
        isOpen={isModalOpen}
        heading="2N access management"
        onClose={() => setIsModalOpen(false)}
      >
        <AccessManagement2NModal />
      </BrikkModal>
    </>
  );
};
